import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivate } from '@angular/router';
import { OrderPreparationService } from '@core/data-access/services/order-preparation.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderProcessingGuard implements CanActivate {
  readonly #orderProcessingService = inject(OrderPreparationService);

  readonly #isOrderProcessing = toObservable(this.#orderProcessingService.isOrderProcessing);

  canActivate(): Observable<boolean> {
    return this.#isOrderProcessing.pipe(map((processing) => !processing));
  }
}
